export const SortBy = {
  age: 'Newest',
  name: 'Alphabetically',
  price: 'Cheapest',
};
